var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpotRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3892 7.08884C15.5758 7.28793 15.5657 7.60057 15.3666 7.78714C11.1675 11.7222 4.57736 11.5056 0.642594 7.30685C0.456025 7.10776 0.466173 6.79512 0.665262 6.60855C0.864351 6.42198 1.17699 6.43213 1.36356 6.63122C4.92547 10.4321 10.8903 10.6278 14.691 7.06618C14.89 6.87961 15.2027 6.88975 15.3892 7.08884Z",
    fill: "#0F20E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2652 6.7503C15.5365 6.77863 15.7336 7.02158 15.7052 7.29295L15.4153 10.0701C15.387 10.3415 15.144 10.5385 14.8726 10.5102C14.6013 10.4819 14.4042 10.2389 14.4326 9.96754L14.7225 7.19036C14.7508 6.91899 14.9938 6.72197 15.2652 6.7503Z",
    fill: "#0F20E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7052 7.29401C15.6764 7.56532 15.433 7.76187 15.1617 7.73301L12.5347 7.45354C12.2634 7.42468 12.0669 7.18134 12.0957 6.91002C12.1246 6.63871 12.3679 6.44216 12.6393 6.47103L15.2662 6.75049C15.5375 6.77935 15.7341 7.02269 15.7052 7.29401Z",
    fill: "#0F20E8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotRight);
export default __webpack_public_path__ + "static/media/spot_right.4acd4ca057a799110520888465ae6fa2.svg";
export { ForwardRef as ReactComponent };